/*
Takes in an amount in dollars. Returns amount in cents.

Cents are always returned as a whole number.

Examples
100.11 => 10011
100.10 => 10010
100 => 10000
2 => 200

*/

export function getAmountInCents(amountInDollars) {
  // .toFixed(0) here fixes weird JS number issues where 4.06 will turn into 4.059999999994 (for example)
  return (Number(amountInDollars) * 100).toFixed(0);
}
